var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinterest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M6.465 20.414c-.077-.643-.21-2.498.044-3.572.229-.971 1.481-6.183 1.481-6.183s-.378-.745-.378-1.847c0-1.73 1.019-3.021 2.288-3.021 1.078 0 1.598.796 1.598 1.752 0 1.067-.69 2.663-1.047 4.142-.297 1.238.631 2.248 1.872 2.248 2.246 0 3.973-2.332 3.973-5.697 0-2.978-2.175-5.06-5.279-5.06-3.596 0-5.706 2.655-5.706 5.398 0 1.069.418 2.215.94 2.839.104.123.118.23.088.356-.096.393-.31 1.238-.352 1.411-.054.228-.182.276-.421.167C3.986 12.623 3 10.352 3 8.527 3 4.603 5.897 1 11.35 1c4.384 0 7.791 3.075 7.791 7.184 0 4.287-2.746 7.737-6.558 7.737-1.28 0-2.484-.654-2.896-1.428 0 0-.634 2.375-.787 2.957-.286 1.081-1.288 2.778-1.572 3.261-.283.483-.786.346-.863-.297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.4a7ac72e7cca4e0c8e5b1645f1b3dde0.svg";
export { ForwardRef as ReactComponent };